import { useMutation, useQueryClient } from "@tanstack/react-query";

import { unenrollmentRequest } from "@/apiQueries/multisigUnenrollment/multisigUnenrollmentRequest";
import {
  MULTISIG_UNENROLLMENT_QUERY_KEY,
  MULTISIG_UNENROLLMENT_URL,
} from "@/apiQueries/multisigUnenrollment/useMultisigUnenrollment";

import type { UnenrollmentError } from "@/helpers/unenrollmentErrors";

import type { MultisigUnenrollmentStatus } from "@/types";

export const useMultisigUnenrollmentCancel = () => {
  const queryClient = useQueryClient();

  return useMutation<MultisigUnenrollmentStatus, UnenrollmentError, { txId: string }>({
    mutationFn: (vars) =>
      unenrollmentRequest<MultisigUnenrollmentStatus>(
        `${MULTISIG_UNENROLLMENT_URL}/${encodeURIComponent(vars.txId)}`,
        { method: "DELETE" },
      ),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: MULTISIG_UNENROLLMENT_QUERY_KEY }),
  });
};
